$(document).ready(function () {
  // Initialize lax library
  lax.init();
  // Add a driver that we use to control our animations
  lax.addDriver("scrollY", function () {
    return window.scrollY;
  });
  lax.addElements(
    "[data-scroll-scale-out]", // Element selector rule
    {
      // Animation data
      scrollY: {
        scale: [
          ["elInY", "elCenterY", "elOutY"],
          [1.4, 1.25, 1],
        ],
      },
    },
  );
  lax.addElements("[data-scroll-cross]", {
    scrollY: {
      translateX: [
        ["elInY", "elCenterY", "elOutY"],
        [-300, 550, 1400],
      ],
      opacity: [
        ["elInY", "elOutY"],
        [1, 0],
      ],
    },
  });

  // Add lax properties to the img element
  lax.addElements("[data-scroll-y-full]", {
    scrollY: {
      translateY: [
        ["elInY", "elCenterY", "elOutY"],
        [-300, 300, 900],
      ],
    },
  });
  lax.addElements("[data-scroll-opacity]", {
    scrollY: {
      opacity: [
        ["elInY", "elOutY"],
        [0, 1],
      ],
    },
  });
  //============================================
  const topBars = $(".top-bar");
  let currentIndex = 0;

  function toggleOpacity() {
    topBars.removeClass("opacity-100").addClass("opacity-0");
    topBars.eq(currentIndex).removeClass("opacity-0").addClass("opacity-100");
    currentIndex = (currentIndex + 1) % topBars.length;
    setTimeout(toggleOpacity, 3000); // Adjust the delay as needed
  }

  toggleOpacity();

  let lastScroll = 0;
  $(window).on("scroll", function () {
    lastScroll = $(this).scrollTop();
    window.requestAnimationFrame(() => {
      $("header").toggleClass("shadow-md header_main", lastScroll >= 70);
    });
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var spanElement = $("header > span");
    var navElement = $("header .nav_icon span, header .nav_icon small");

    spanElement.toggleClass("bg-transparent", scroll < 70);
    spanElement.toggleClass("bg-tertiary", scroll >= 70);

    navElement.toggleClass("bg-tertiary", scroll < 70);
    navElement.toggleClass("bg-primary", scroll >= 70);
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var spanElement = $("header .navMenu");

    var headerInnerExists = $("header").hasClass("header-alt");

    if (!headerInnerExists) {
      spanElement.toggleClass("text-tertiary", scroll < 70);
      spanElement.toggleClass("text-primary", scroll >= 70);
    }
  });

  const flerLogo = $(".fler-logo");

  $(window).scroll(function () {
    const scroll = $(window).scrollTop();

    if (scroll >= 70) {
      flerLogo.addClass("animate-logo-up");
    } else {
      flerLogo.removeClass("animate-logo-up");
    }
  });

  $(document).ready(($) => {
    $("img").each(function () {
      const img = $(this);
      const width = img.width();
      const height = img.height();

      if (width && height) {
        img.attr("width", width);
        img.attr("height", height);
      }
    });
  });

  $("img").each(function () {
    var $img = $(this);
    var altText = $img.attr("alt");

    // Process only if alt is missing or empty
    if (!altText || altText.trim() === "") {
      var src = $img.attr("src");
      if (src) {
        // Extract filename (no extension)
        var fileName = src.split("/").pop().split(".")[0];

        // Remove long random hash-like strings (UUIDs or long alphanumerics)
        fileName = fileName.replace(/[-_]?[a-f0-9]{8,}[-_a-f0-9]*/gi, "");

        // Remove digits, dashes, underscores, and extra spaces
        var cleanName = fileName
          .replace(/[0-9]/g, "") // remove numbers
          .replace(/[-_]+/g, " ") // replace - and _ with spaces
          .replace(/\s{2,}/g, " ") // collapse multiple spaces
          .trim();

        // Capitalize first letter
        if (cleanName.length > 0) {
          cleanName = cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
        } else {
          cleanName = "Image";
        }

        // Set alt attribute
        $img.attr("alt", cleanName);
      }
    }
  });

  $("a").each(function () {
    var text = $(this).text().trim() || $(this).attr("title") || "link";
    $(this).attr("aria-label", text);
  });

  //============================================
  // Set default opacity for all tab buttons
  $("[data-tabs-target]").css("opacity", 0.5);

  // Hide all tabs except the first one
  $('[id^="default-tab-content"] > div:not(:first)').addClass("hidden");

  // Find the first button with aria-selected="true" and update styles
  var $initialTab = $("[data-tabs-target]").filter('[aria-selected="true"]');
  $initialTab.css("opacity", 1.0).addClass("border-b");

  // Handle tab button click
  $("[data-tabs-target]").on("click", function () {
    // Hide all tab content
    $('[id^="default-tab-content"] > div').addClass("hidden");

    // Show the selected tab content
    $($(this).data("tabs-target")).removeClass("hidden");

    // Update tab button styles
    $("[data-tabs-target]").css("opacity", 0.5).removeClass("border-b");
    $(this).css("opacity", 1.0).addClass("border-b");
  });

  //=====================================
  // Click event for the buttons
  $(".radio-select").on("click", function () {
    // Remove the 'hidden' class from all spans
    $(".radio-select span").addClass("hidden");

    // Get the index of the clicked button
    var index = $(this).index() + 1;

    // Remove the 'hidden' class from the corresponding span
    $(".selection-text")
      .eq(index - 1)
      .find("span")
      .removeClass("hidden");
  });
  //=====================================
  // Wait for the document to be ready

  // Handle click event on the nav_icon
  $(".nav_icon").click(function () {
    // Toggle the visibility of the menu-mobile on each click
    $(".menu-mobile").toggle();

    $(".nav_icon").toggleClass("group");

    // Toggle the 'menu-open' class on the body to control overflow
    $("body").toggleClass("overflow-hidden");

    // Get the .navMenu element
    var navMenu = $(".navMenu");

    // Toggle classes based on the existence of text-tertiary class
    if (navMenu.hasClass("text-tertiary")) {
      navMenu.removeClass("text-tertiary").addClass("text-primary");
    } else {
      navMenu.removeClass("text-primary").addClass("text-tertiary");
    }

    var headerInnerExists = $(this).closest("header").hasClass("header-alt");

    if (!headerInnerExists) {
      $(this).closest("header").addClass("header-main");
    }

    // Always toggle the menu-open class in .navMenu
    navMenu.toggleClass("menu-open");

    // Adjust margin-top of .fler-logo div when menu opens
    if (navMenu.hasClass("menu-open")) {
      $(".fler-logo").css("margin-top", "0");
    } else {
      // Reset margin-top when menu closes
      $(".fler-logo").css("margin-top", ""); // or "auto" depending on your design
    }
  });
  //=====================================
  // Function to set height based on screen width
  function setHeightBasedOnWidth() {
    // Check the device width
    if ($(window).width() >= 768) {
      // Get the height of the content inside the first class
      var tabContentHeight = $(".tab-wrapper-inner").outerHeight();

      // Set the height of the second class based on the content height
      $(".default-tab-content").css("height", tabContentHeight);
    } else {
      // If the width is less than 768px, reset the height to auto or any desired value
      $(".default-tab-content").css("height", "auto");
    }
  }

  // Initial height setting
  setHeightBasedOnWidth();

  // Listen for window resize events
  $(window).resize(function () {
    // Update height when the window is resized
    setHeightBasedOnWidth();
  });
  //=====================================
  var defaultTab = $("#default-tab");
  var buttons = defaultTab.find(".tab-btn");

  // Show the tab-data of the first button by default
  var firstButton = buttons.first();
  var firstTabData = firstButton.find(".tab-data");
  firstTabData.animate({ height: "toggle" });

  buttons.on("click", function () {
    var clickedButton = $(this);
    var targetTabData = clickedButton.find(".tab-data");

    // Check if the clicked tab is already active
    var isAlreadyActive = targetTabData.is(":visible");

    // Hide all tab-data elements with height animation
    $(".tab-data").not(targetTabData).animate({ height: "hide" });

    // Show the tab-data of the clicked button if it's not already active
    if (!isAlreadyActive) {
      targetTabData.animate({ height: "toggle" });
    }
  });
  //============================================
  $(".btn-review").click(function () {
    // Find the reviews-wrapper element
    var reviewsWrapper = $(".reviews-wrapper");

    // Replace the height class
    reviewsWrapper.removeClass("h-[40rem]").addClass("h-auto");

    // Find the review-shadow element and add the hidden class
    reviewsWrapper.find(".review-shadow").addClass("hidden");

    // Add the hidden class to the button
    $(this).hide();
  });
  //============================================
  // Target the contact form
  var contactForm = $(".type-form");

  // Attach a function to the change event on input and textarea elements within the form
  contactForm.find("input, textarea").on("input", function () {
    // Find the corresponding field wrapper for the current input or textarea
    var fieldWrapper = $(this).closest("[field-wrapper]");

    // Check if the input or textarea has a value
    if ($(this).val().trim() !== "") {
      // Add the not-empty class to the field wrapper
      fieldWrapper.addClass("not-empty");
    } else {
      // Remove the not-empty class from the field wrapper
      fieldWrapper.removeClass("not-empty");
    }
  });

  //=================================
  // Add click event listener to each details element
  $("details").on("click", function () {
    // Close all other details elements
    $("details").not(this).removeAttr("open");
  });

  //================================
  $(".js-toggle-accordion").click(function (e) {
    e.preventDefault(); // Prevent default anchor behavior

    var container = $(this).next(".set-details-container");
    var arrow = $(this).find(".set-details-arrow"); // Look for .set-details-arrow within the clicked element

    // Toggle the visibility of the set-details-container
    container.toggleClass("expanded");

    // Defer layout read to the next animation frame to avoid forced reflow
    window.requestAnimationFrame(() => {
      var maxHeight = container.hasClass("expanded") ? container[0].scrollHeight + "px" : "0";
      container.css("max-height", maxHeight);

      // Add or remove classes based on the presence of 'expanded' class
      arrow.toggleClass("transform rotate-180 transition-all duration-300 ease", container.hasClass("expanded"));
    });
  });

  // Hide the login prompt by default
  $(".login-prompt").addClass("hidden");

  // Show login prompt when prompt-btn is clicked
  $(".prompt-btn").click(function () {
    $(".login-prompt").removeClass("hidden");
  });

  // Hide login prompt when prompt-close is clicked
  $(".prompt-close").click(function () {
    $(".login-prompt").addClass("hidden");
  });

  $('[data-step] input[type="radio"]').change(function () {
    var allGroupsChecked = true;

    $('[data-step="' + $(this).closest("[data-step]").attr("data-step") + '"] input[type="radio"]').each(function () {
      var groupName = $(this).attr("name");
      if ($('[name="' + groupName + '"]:checked').length === 0) {
        allGroupsChecked = false;
        return false; // Exit the loop early since we found an unchecked radio in this group
      }
    });
    var stepBtn = $(this).closest("[data-step]").find(".step-button");

    if (allGroupsChecked) {
      if (stepBtn.attr("sold") == undefined) {
        stepBtn.removeAttr("disabled").removeClass("opacity-25 pointer-events-none");
      }
    } else {
      stepBtn.attr("disabled", "disabled").addClass("opacity-25 pointer-events-none");
    }
  });

  // Show choose-plan by default
  $(".choose-plan").addClass("block").removeClass("hidden");

  // Show/hide frequency options based on frequency frequency selection
  $('[data-step] input[name="frequency"]').change(function () {
    var selectedfrequency = $(this).val();
    $("div[data-frequency]").addClass("hidden");
    $('div[data-frequency*="' + selectedfrequency + '"]').removeClass("hidden");
    // Reset selected frequency when changing frequency frequency
    $('input[name="blades"]').prop("checked", false);
    $('input[name="blades"]').trigger("change");
    // Show choose-plan when changing frequency frequency
    $(".choose-plan").removeClass("hidden").addClass("block");
    // Hide data-selected when changing frequency frequency
    $("span[data-selected]").removeClass("block").addClass("hidden");
    // Add hidden class to frequency-label when data-type is checked
    $("div[data-frequency-label]").addClass("hidden");
  });

  // When expanding the details element
  $("#choose-plan").on("toggle", function () {
    if ($(this).prop("open")) {
      // Details element is expanded
      // Show choose-plan
      $(".choose-plan").removeClass("hidden").addClass("block");
      // Hide data-selected
      $("span[data-selected]").removeClass("block").addClass("hidden");
    } else {
      // Details element is collapsed
      var selectedFrequency = $('#choose-plan input[name="blades"]:checked').siblings("label").text();
      $("span[data-selected]").text(selectedFrequency);
      if ($('input[name="blades"]:checked').length > 0) {
        $("span[data-selected]").removeClass("hidden").addClass("block");
        $(".choose-plan").removeClass("block").addClass("hidden");
      }
    }
  });

  // When both frequency and plan are checked, collapse the details element
  $('input[name="blades"]').change(function () {
    if ($('[data-step] input[name="frequency"]:checked').length > 0 && $('input[name="blades"]:checked').length > 0) {
      $("#choose-plan").removeAttr("open");
    }
  });
});

$(document).ready(function () {
  // Listen for changes in the data-added attribute of any .product-card
  $(".product-card").on("DOMSubtreeModified", function () {
    var hasDataAdded = false;
    // Loop through each .product-card
    $(".product-card").each(function () {
      // Check if the current .product-card has the data-added attribute
      if ($(this).attr("data-added")) {
        hasDataAdded = true;
        return false; // Exit the loop if data-added attribute is found
      }
    });
    // Check if any .product-card has data-added attribute
    if (hasDataAdded) {
      // If any .product-card has data-added attribute, add hidden class to .skip-button
      $(".skip-button").addClass("hidden");
    } else {
      // If no .product-card has data-added attribute, remove hidden class from .skip-button
      $(".skip-button").removeClass("hidden");
    }
  });
});

$(document).ready(function () {
  // Initialize a variable to store the maximum height
  var maxHeight = 0;

  // Iterate over each .flip-box-content to find the maximum height
  $(".flip-box-content").each(function () {
    // Get the current height of the flip-box-content
    var currentHeight = $(this).outerHeight();

    // Update maxHeight if the current height is greater
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });

  // Apply the maximum height to all .flip-box elements
  $(".flip-box").css("height", maxHeight);
  $(".flip-box-content").css("height", maxHeight);
});

function generateWave(element) {
  const wave = document.querySelector(element);
  if (!wave) return;

  // Defer layout reads to next animation frame
  window.requestAnimationFrame(() => {
    const rect = wave.getBoundingClientRect(); // Single layout read
    const width = rect.width;
    const height = rect.height;

    const offset = height - 50;
    const amplitude = width < 500 ? 15 : 25;
    const frequency = width < 500 ? 0.7 : 1.1;
    const phase = width < 500 ? -50 : -80;
    const points = 30;
    const inverted = true;
    const units = (2 * Math.PI * frequency) / points;
    const path = "clip-path: polygon(100% 100%, 0% 100% ";
    const invertedPath = "clip-path: polygon(100% 0%, 0% 0% ";

    let clipPathString = inverted ? invertedPath : path;
    const radPhase = (phase * Math.PI) / 180;

    // Build wave path
    for (let i = 0; i <= points; i++) {
      const val = offset + amplitude * Math.cos(i * units + radPhase);
      const valY = ((val / height) * 100).toFixed(2);
      const valX = ((i * 100) / points).toFixed(2);
      clipPathString += `, ${valX}% ${valY}%`;
    }

    clipPathString += ");";
    wave.style = clipPathString;
  });
}

// Initialize after DOM load
(() => {
  generateWave(".wave-container");
})();

const items = document.querySelectorAll(".steps-slider .slider-item");
const bg = document.querySelector(".slider-bg");

let currentIndex = 0;

function equalizeHeights() {
  if (items.length === 0) return;
  // Reset heights first
  items.forEach((item) => {
    item.style.height = "auto";
  });

  let maxHeight = 0;

  items.forEach((item) => {
    maxHeight = Math.max(maxHeight, item.offsetHeight);
  });

  items.forEach((item) => {
    item.style.height = `${maxHeight}px`;
  });
}

function updateSlider() {
  if (items.length === 0 || !bg) return;
  const activeItem = items[currentIndex];
  const isMobile = window.innerWidth < 1024;

  bg.style.width = `${activeItem.offsetWidth}px`;
  bg.style.height = `${activeItem.offsetHeight}px`;

  if (isMobile) {
    bg.style.transform = `translateY(${activeItem.offsetTop}px)`;
  } else {
    bg.style.transform = `translateX(${activeItem.offsetLeft}px)`;
  }

  items.forEach((item) => item.classList.remove("slider-item-active"));

  setTimeout(() => {
    activeItem.classList.add("slider-item-active");
  }, 600);
}

if (items.length > 0 && bg) {
  // Initial setup
  equalizeHeights();
  updateSlider();

  setInterval(() => {
    currentIndex = (currentIndex + 1) % items.length;
    updateSlider();
  }, 5000);

  // Recalculate on resize
  window.addEventListener("resize", () => {
    equalizeHeights();
    updateSlider();
  });
}

  const buttons = document.querySelectorAll(".fragrance-btn");
  const images = document.querySelectorAll(".fragrance-image");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const target = button.dataset.image;

      buttons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      images.forEach((img) => {
        img.classList.remove("active-image");
        img.classList.add("opacity-0");
        img.classList.remove("opacity-100");
      });

      const activeImage = document.getElementById(target);

      activeImage.classList.add("active-image");
      activeImage.classList.remove("opacity-0");
      activeImage.classList.add("opacity-100");
    });
  });
